/**
 * Ecolab OneTrust category taxonomy.
 * Confirm the authoritative list + labels in the OneTrust admin console before
 * shipping — the C0007 bucket is non-standard and was inferred from legacy code.
 */
export const CONSENT_CATEGORIES = {
  strictlyNecessary: "C0001", // never blockable
  performance: "C0002", // Elastic APM (RUM), analytics
  functional: "C0003", // chatbot (NICE CXone)
  targeting: "C0004", // GTM, Salesforce Interactions/Evergage, Sitecore CDP
  social: "C0005", // social embeds
  video: "C0007", // YouTube embeds (already gated correctly)
} as const;

export type ConsentCategory = keyof typeof CONSENT_CATEGORIES;

/**
 * Categories whose scripts cannot be torn down in place once started
 * (APM init, Cloud SDK init, running tags). When any of these is downgraded
 * from granted -> not-granted, the only reliable teardown is a reload.
 */
export const RELOAD_ON_DOWNGRADE: ConsentCategory[] = [
  "performance",
  "functional",
  "targeting",
  "social",
];

/**
 * Every category whose cookies may be swept when the user has not granted it.
 * `strictlyNecessary` is excluded by definition — it is never blockable, and
 * several C0001 cookies (`__cf_bm`, `TapAd_TS`, `LSKey-c$CookieConsentPolicy`,
 * `UserMatchHistory`, `pctrk`) are ALSO registered under optional categories in
 * this tenant's inventory, so a naive "deny wins" sweep would delete them.
 */
export const SWEEPABLE_CATEGORIES: ConsentCategory[] = [
  "performance",
  "functional",
  "targeting",
  "social",
  "video",
];
